import axios from "axios";
import React, { useEffect, useState, useMemo } from "react";
import { getAxiosConfig, shuffleArray } from "../../../utils/helpers";
import {
  Box,
  Button,
  Checkbox,
  VStack,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from "@chakra-ui/react";
import { FiChevronDown } from "react-icons/fi";

const SubFilterBar = ({
  filter,
  subFilter,
  setSubFilter,
  onFinally = () => {},
  setFilterLoading = () => {},
}) => {
  const [totalSubFilterOptions, setTotalSubFilterOptions] = useState([]);
  const [isAttributesOpen, setIsAttributesOpen] = useState(false);

  useEffect(() => {
    async function getSubFilters() {
      try {
        setFilterLoading(true);
        setTotalSubFilterOptions([]);
        const {
          data: { data },
        } = await axios.get(
          `${process.env.REACT_APP_BACK_URL}/api/material/get-all-filter`,
          getAxiosConfig({
            materialType:
              filter?.types &&
              Array.isArray(filter?.types) &&
              filter?.types?.length
                ? filter?.types?.join(",")
                : "",
            brand:
              filter?.brands &&
              Array.isArray(filter?.brands) &&
              filter?.brands?.length
                ? filter?.brands?.join(",")
                : "",
            search: (filter?.search || "")?.trim(),
          }),
        );
        // console.log(data);
        let arr = [];
        Object.keys(data?.filter).forEach((key) => {
          if (
            Array.isArray(data?.filter[key]) &&
            data?.filter[key].length > 0
          ) {
            data?.filter[key]?.forEach((value) => {
              arr.push({ key, value });
            });
          }
        });
        const shuffledArray = shuffleArray(arr).flat();
        let finalArr = [];
        shuffledArray.forEach((obj) => {
          if (
            obj?.key in subFilter &&
            subFilter?.[obj?.key]?.includes(obj?.value)
          ) {
            finalArr = [obj, ...finalArr];
          } else {
            finalArr.push(obj);
          }
        });
        // Object.keys(subFilter).forEach((key) => {

        // })
        // const finalArr = [
        //   ...selectedOne,
        //   ...shuffledArray.filter((obj) => {
        //     return !(
        //       obj?.key in subFilter &&
        //       subFilter?.[obj?.key]?.includes(obj?.value)
        //     );
        //   }),
        // ];
        // console.log("finalArr", finalArr, shuffleArray(arr).flat());
        setTotalSubFilterOptions(finalArr);
        //
        // setTotalSubFilterOptions();
      } catch (error) {
        // console.log("ERROR : IN FILTERS", error?.message);
      } finally {
        onFinally();
        setFilterLoading(false);
      }
    }
    getSubFilters();
  }, [JSON.stringify(filter)]);

  function handlesubFilterChange(key, val) {
    if (subFilter?.[key] && Array.isArray(subFilter?.[key])) {
      if (subFilter?.[key]?.includes(val)) {
        setSubFilter((p) => ({
          ...p,
          [key]: p?.[key]?.filter((i) => i != val),
        }));
      } else {
        setSubFilter((p) => ({ ...p, [key]: [...p?.[key], val] }));
      }
    } else {
      setSubFilter((p) => ({ ...p, [key]: [val] }));
    }
  }

  function isSelected(key, val) {
    return (
      subFilter?.[key] &&
      Array.isArray(subFilter?.[key]) &&
      subFilter?.[key]?.includes(val)
    );
  }

  // console.log({ filter, totalSubFilterOptions });

  let keyMap = {
    subCategory: "Sub Category",
    size: "Size",
    category: "Category",
    color: "Color",
    floorType: "Floor Type",
  };

  // Group options by key
  const groupedOptions = useMemo(() => {
    const grouped = {};
    totalSubFilterOptions.forEach((obj) => {
      if (!grouped[obj.key]) {
        grouped[obj.key] = [];
      }
      grouped[obj.key].push(obj.value);
    });
    return grouped;
  }, [totalSubFilterOptions]);

  // Calculate selected attributes count
  const selectedAttributesCount = useMemo(() => {
    let count = 0;
    Object.keys(subFilter).forEach((key) => {
      if (Array.isArray(subFilter[key]) && subFilter[key].length > 0) {
        count += subFilter[key].length;
      }
    });
    return count;
  }, [JSON.stringify(subFilter)]);

  return (
    <>
      {totalSubFilterOptions && (
        <Popover
          isOpen={isAttributesOpen}
          onClose={() => setIsAttributesOpen(false)}
          placement="top"
          closeOnBlur={true}
        >
          <PopoverTrigger>
            <Box
            // position={isFixed ? "fixed" : "relative"}
            // bottom={isFixed ? "20px" : "auto"}
            // left="50%"
            // transform="translateX(-50%)"
            // zIndex={89}
            >
              <Button
                rightIcon={<FiChevronDown />}
                onClick={() => setIsAttributesOpen(!isAttributesOpen)}
                variant="outline"
                borderRadius="lg"
                bg={selectedAttributesCount > 0 ? "teal.50" : "white"}
                borderColor={
                  selectedAttributesCount > 0 ? "teal.500" : "gray.300"
                }
                color={selectedAttributesCount > 0 ? "teal.600" : "gray.700"}
                _hover={{
                  bg: selectedAttributesCount > 0 ? "teal.100" : "gray.50",
                }}
              >
                Attributes{" "}
                {selectedAttributesCount > 0 && `(${selectedAttributesCount})`}
              </Button>
            </Box>
          </PopoverTrigger>
          <PopoverContent maxW="400px">
            <PopoverArrow />
            <PopoverBody>
              <Text fontWeight="bold" mb={3} fontSize="sm" color="gray.700">
                Filter by Attributes
              </Text>
              <VStack align="stretch" spacing={3} maxH="400px" overflowY="auto">
                {Object.entries(groupedOptions).map(([key, values]) => (
                  <Box
                    key={key}
                    borderWidth="1px"
                    borderRadius="md"
                    p={2}
                    bg="gray.50"
                  >
                    <Text fontWeight="semibold" fontSize="sm" mb={2}>
                      {keyMap[key] || key}
                    </Text>
                    <VStack align="stretch" spacing={1} pl={4}>
                      {values.map((value) => (
                        <Checkbox
                          key={`${key}-${value}`}
                          isChecked={isSelected(key, value)}
                          onChange={() => handlesubFilterChange(key, value)}
                          colorScheme="teal"
                          size="sm"
                        >
                          <Text fontSize="sm" textTransform="capitalize">
                            {String(value || "")
                              ?.split("-")
                              ?.join(" ")}
                          </Text>
                        </Checkbox>
                      ))}
                    </VStack>
                  </Box>
                ))}
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}
    </>
  );
};

export default SubFilterBar;
